import PropTypes from 'prop-types';

import FitSurveyValue from 'components/icons/FitSurveyValue';

import css from 'styles/components/reviews/fitSurvey.scss';

const makeDimension = (rating, leftLabel, rightLabel) => (
  <div className={css.dimension}>
    <div className={css.dimensionLabels}>
      <span>{leftLabel}</span>
      <span>{rightLabel}</span>
    </div>
    <FitSurveyValue value={rating} />
  </div>
);

const makeFitSurvey = ({ archRating, sizeRating, widthRating }) => (
  <div className={css.container}>
    {sizeRating && makeDimension(sizeRating, 'Runs Small', 'Runs Large')}
    {widthRating && makeDimension(widthRating, 'Runs Narrow', 'Runs Wide')}
    {archRating && makeDimension(archRating, 'Poor Support', 'Great Support')}
  </div>
);

const FitSurvey = props => {
  const { archRating, sizeRating, widthRating } = props;
  const hasRatings = [archRating, sizeRating, widthRating].some(rating => !!rating);
  return hasRatings && makeFitSurvey(props);
};

FitSurvey.propTypes = {
  sizeRating: PropTypes.number,
  widthRating: PropTypes.number,
  archRating: PropTypes.number
};

export default FitSurvey;
